import { getProjectsFestival } from '@/domain/project-festival/actions/get-projects-festival.action';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

export const deleteProjectFestival = createAppAsyncThunk(
  'projectFestival/deleteProjectFestival',
  async (
    id: number,
    { extra: { projectFestivalGateway, snackbarGateway }, dispatch },
  ): Promise<void> => {
    try {
      await projectFestivalGateway.delete(id);
      showSnackbarSuccess(snackbarGateway);
      dispatch(getProjectsFestival());
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('DeleteProject.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('DeleteProject.Message.error'));
}
